<template>
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M3.03499 15.2916V6.41295H0.5V15.2916H3.03499ZM4.30665 15.2916V6.37813C5.24668 6.07795 6.20134 3.88086 6.41801 1.49332L6.4704 0.916626H7.04927C8.20406 0.916626 8.81758 0.98681 9.49828 1.32674C10.5069 1.8324 11.0633 2.8192 11.0633 4.29898V5.56736H13.176C13.882 5.56735 14.5497 5.88843 14.9907 6.44002C15.4317 6.9916 15.5983 7.71387 15.4433 8.40304L14.3025 13.4766C14.0639 14.5377 13.1222 15.2916 12.0352 15.2916H4.30665Z"
      fill="currentColor"
    />
  </svg>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';
@Component
export default class FilledLikeIcon extends Vue {}
</script>
